import React from "react";
import clsx from "~/sdk/clx"
import type { JSX } from "react"

function Dot({
    index,
    children,
    className,
    ...props
}: {
    index: number
} & React.JSX.IntrinsicElements['button']) {
    return (
        <button
            data-dot={index}
            aria-label={`go to slider item ${index}`}
            {...props}
            className={clsx('focus:outline-none group', className)}
        >
            {children}
        </button>
    )
}

function Slider(props: React.JSX.IntrinsicElements['ul']) {
    return <ul data-slider {...props} />
}

function Item({ index, ...props }: React.JSX.IntrinsicElements['li'] & { index: number }) {
    return <li data-slider-item={index} {...props} />
}

function NextButton(props: React.JSX.IntrinsicElements['button']) {
    return <button data-slide='next' aria-label='Next item' {...props} />
}

function PrevButton(props: React.JSX.IntrinsicElements['button']) {
    return <button data-slide='prev' aria-label='Previous item' {...props} />
}

Slider.Dot = Dot
Slider.Item = Item
Slider.NextButton = NextButton
Slider.PrevButton = PrevButton

export default Slider
